module.exports = __webpack_public_path__ + "static/eindruecke11-9c9f6e83c54cdef30e00c48bed614a13.jpg";